exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pageHeader-f3725{position:relative;display:flex;justify-content:space-between;align-items:start;padding:0 0 16px;background-color:inherit}.pageHeader-f3725 .title-86a12{white-space:nowrap;margin-right:12px;font-size:24px;font-weight:600;line-height:32px}.pageHeader-f3725 .rightContent-fb465{display:flex;align-items:center;margin:4px 0;white-space:nowrap}.pageHeader-f3725 .rightContent-fb465>*{margin-left:12px}", ""]);

// Exports
exports.locals = {
	"pageHeader": "pageHeader-f3725",
	"title": "title-86a12",
	"rightContent": "rightContent-fb465"
};